import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { PersonalInfo } from "./types";

interface ContactInfoStepProps {
  personalInfo: PersonalInfo;
  onPersonalInfoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ContactInfoStep = ({ personalInfo, onPersonalInfoChange }: ContactInfoStepProps) => {
  return (
    <>
      <div className="text-center">
        <h3 className="text-2xl font-bold text-primary-dark">
          Contact Information
        </h3>
        <p className="text-neutral mt-2">
          How can we reach you?
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <Label htmlFor="email" className="text-primary-dark font-medium">Email Address</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={personalInfo.email}
            onChange={onPersonalInfoChange}
            placeholder="john.doe@example.com"
            className="mt-1.5 bg-white/50 backdrop-blur-sm border-[#E5DEFF] focus:border-primary focus:ring-primary/20 transition-colors placeholder:text-neutral/60"
          />
        </div>

        <div>
          <Label htmlFor="phone" className="text-primary-dark font-medium">Phone Number</Label>
          <Input
            id="phone"
            name="phone"
            type="tel"
            value={personalInfo.phone}
            onChange={onPersonalInfoChange}
            placeholder="(555) 555-5555"
            className="mt-1.5 bg-white/50 backdrop-blur-sm border-[#E5DEFF] focus:border-primary focus:ring-primary/20 transition-colors placeholder:text-neutral/60"
          />
        </div>
      </div>
    </>
  );
};

export default ContactInfoStep;